import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import StatisticsModule from '../components/StatisticsModule';
import MedicalTicketModal from '../components/MedicalTicketModal';
import TechnicalTicketModal from '../components/TechnicalTicketModal';
import { LuLayoutDashboard } from "react-icons/lu";

import { 
  ClipboardList, 
  X, 
  CheckCircle,
  Clock,
  User,
  Plus,
  Bell,
  AlertTriangle,
  CalendarDays
} from 'lucide-react';
import { GiHorseHead } from 'react-icons/gi';
import { PiFarm } from "react-icons/pi";
import { MdWhereToVote } from "react-icons/md";
import { FaHandHoldingMedical, FaWrench } from "react-icons/fa6";
import { LuBellRing } from "react-icons/lu";
import { 
  collection, 
  query, 
  where, 
  onSnapshot,
  doc,
  updateDoc,
  arrayUnion,
  addDoc,
  orderBy,
  getDocs
} from 'firebase/firestore';
import { db } from '../firebase/config';

export default function TableauDeBordPage() {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showNewTicketModal, setShowNewTicketModal] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [horses, setHorses] = useState([]);
  const [ticketType, setTicketType] = useState('medical');
  const [showMedicalModal, setShowMedicalModal] = useState(false);
  const [showTechnicalModal, setShowTechnicalModal] = useState(false);
  const [ticketToClose, setTicketToClose] = useState(null);
  const [showCloseConfirm, setShowCloseConfirm] = useState(false);
  const [echeances, setEcheances] = useState([]);
const [loadingEcheances, setLoadingEcheances] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  // Récupération des paramètres de filtrage
  const filterHorseId = location.state?.horseId;
  const filterType = location.state?.filter;
  const filterZoneId = location.state?.zoneId;
  const filterZoneName = location.state?.zoneName;

  // Charger les animaux pour l'autocomplétion
  useEffect(() => {
    const loadAnimaux = async () => {
      try {
        const animauxSnapshot = await getDocs(collection(db, 'animaux'));
        const animauxData = [];
        animauxSnapshot.forEach((doc) => {
          const data = doc.data();
          animauxData.push({
            id: doc.id,
            name: data.nom || '',
            sire: data.sire || '',
            type: data.type || 'equide'
          });
        });
        animauxData.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
        setHorses(animauxData);
      } catch (error) {
        console.error('Erreur chargement animaux:', error);
      }
    };
    loadAnimaux();
  }, []);

  // Charger les tickets en temps réel avec filtrage
  useEffect(() => {
    let q;
    
    // Filtre pour les tickets médicaux par cheval
    if (filterHorseId && filterType === 'medical') {
      q = query(
        collection(db, 'tickets'),
        where('horseId', '==', filterHorseId),
        where('statut', '==', 'ouvert'),
        where('type', '==', 'medical')
      );
    }
    // NOUVEAU : Filtre pour les tickets techniques par zone
    else if (filterZoneId && filterType === 'technique') {
      q = query(
        collection(db, 'tickets'),
        where('zoneId', '==', filterZoneId),
        where('statut', '==', 'ouvert'),
        where('type', '==', 'technique')
      );
    }
    // Pas de filtre - afficher tous les tickets
    else {
      q = query(
        collection(db, 'tickets'),
        where('statut', '==', 'ouvert'),
        where('type', 'in', ['medical', 'technique'])
      );
    }

    const unsubscribe = onSnapshot(q, 
      (snapshot) => {
        const ticketsData = [];
        snapshot.forEach((doc) => {
          const data = doc.data();
          if (data.type === 'medical' || data.type === 'technique') {
            ticketsData.push({
              id: doc.id,
              ...data
            });
          }
        });
        // Trier par priorité puis par date
        ticketsData.sort((a, b) => {
          const priorityOrder = { 'haute': 0, 'moyenne': 1, 'basse': 2 };
          const priorityDiff = priorityOrder[a.priority] - priorityOrder[b.priority];
          if (priorityDiff !== 0) return priorityDiff;
          
          const dateA = new Date(a.dateCreation || 0);
          const dateB = new Date(b.dateCreation || 0);
          return dateB - dateA;
        });
        setTickets(ticketsData);
        setLoading(false);
      },
      (error) => {
        console.error('Erreur chargement tickets:', error);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [filterHorseId, filterType, filterZoneId]);

// Charger les échéances et rappels
  useEffect(() => {
    const loadEcheances = async () => {
      try {
        setLoadingEcheances(true);
        
        const aujourd = new Date();
        aujourd.setHours(0, 0, 0, 0);
        const dans30Jours = new Date();
        dans30Jours.setDate(dans30Jours.getDate() + 30);
        
        // Récupérer tous les actes planifiés
        const actesQuery = query(
          collection(db, 'actes'),
          where('statut', '==', 'planifie')
        );
        
        const actesSnapshot = await getDocs(actesQuery);
        const echeancesTemp = [];
        
        // Récupérer aussi les animaux pour avoir leurs noms
        const animauxSnapshot = await getDocs(collection(db, 'animaux'));
        const animauxMap = {};
        animauxSnapshot.forEach(doc => {
          animauxMap[doc.id] = doc.data();
        });
        


// D'abord, collecter tous les actes
const tousLesActes = [];
actesSnapshot.forEach(doc => {
  const acte = { id: doc.id, ...doc.data() };
  tousLesActes.push(acte);
});

// Grouper les actes par date + type + nomActe
const groupesParDateEtType = {};

tousLesActes.forEach(acte => {
  const dateActe = new Date(acte.dateActe);
  dateActe.setHours(0, 0, 0, 0);
  
  // Calculer les jours restants
  const joursRestants = Math.ceil((dateActe - aujourd) / (1000 * 60 * 60 * 24));
  
  // 1. Vérifier si l'ACTE est dans les 30 prochains jours (ou en retard)
  if (joursRestants <= 30) {
    // Créer une clé de groupement unique
    const cleGroupe = `${acte.dateActe}_${acte.typeCategorie}_${acte.nomActe || 'sans_nom'}`;
    
    if (!groupesParDateEtType[cleGroupe]) {
      groupesParDateEtType[cleGroupe] = {
        dateActe: acte.dateActe,
        date: dateActe,
        joursRestants: joursRestants,
        typeCategorie: acte.typeCategorie,
        nomActe: acte.nomActe,
        heureActe: acte.heureActe,
        animaux: [],
        acteIds: []
      };
    }
    
    // Ajouter cet acte au groupe
    groupesParDateEtType[cleGroupe].acteIds.push(acte.id);
    
    // Si c'est un acte groupé
    if (acte.animauxGroupes && acte.animauxGroupes.length > 0) {
      acte.animauxGroupes.forEach(animalId => {
        const animal = animauxMap[animalId];
        if (animal) {
          groupesParDateEtType[cleGroupe].animaux.push({
            id: animalId,
            nom: animal.nom
          });
        }
      });
    }
    // Si c'est un acte individuel
    else if (acte.animalId) {
      const animal = animauxMap[acte.animalId];
      if (animal) {
        groupesParDateEtType[cleGroupe].animaux.push({
          id: acte.animalId,
          nom: animal.nom
        });
      }
    }
  }
  
  // 2. Vérifier si le RAPPEL tombe dans les 30 jours
  if (acte.rappel?.active && acte.rappel?.joursAvant) {
    const dateRappel = new Date(dateActe);
    dateRappel.setDate(dateRappel.getDate() - acte.rappel.joursAvant);
    
    const joursAvantRappel = Math.ceil((dateRappel - aujourd) / (1000 * 60 * 60 * 24));
    
    if (joursAvantRappel >= 0 && joursAvantRappel <= 30) {
      const animal = animauxMap[acte.animalId];
      
      echeancesTemp.push({
        id: `rappel-${acte.id}`,
        type: 'rappel',
        titre: `Rappel: ${acte.nomActe || acte.typeCategorie}`,
        animalNom: animal?.nom || null,
        animalId: acte.animalId,
        animauxGroupes: acte.animauxGroupes || [],
        date: dateRappel,
        dateEcheance: dateActe,
        joursAvantEcheance: acte.rappel.joursAvant,
        joursRestants: joursAvantRappel,
        priority: joursAvantRappel <= 1 ? 'haute' : 
                 joursAvantRappel <= 3 ? 'moyenne' : 'basse',
        statut: 'rappel',
        heureActe: acte.heureActe,
        typeCategorie: acte.typeCategorie
      });
    }
  }
});



// Créer les échéances à partir des groupes
Object.entries(groupesParDateEtType).forEach(([cle, groupe]) => {
  const nomsAnimaux = [...new Set(groupe.animaux.map(a => a.nom))];
  
  if (nomsAnimaux.length > 1) {
    // IMPORTANT : On garde les vrais IDs des actes
    echeancesTemp.push({
      id: `groupe_${cle}`,
      type: 'echeance',
      titre: groupe.nomActe || groupe.typeCategorie,
      animalNom: `${nomsAnimaux.length} animaux`,
      animauxNoms: nomsAnimaux,
      acteIds: groupe.acteIds, // Les VRAIS IDs des actes
      date: groupe.date,
      dateStr: groupe.dateActe,
      joursRestants: groupe.joursRestants,
      priority: groupe.joursRestants < 0 ? 'retard' : 
               groupe.joursRestants === 0 ? 'aujourd' :
               groupe.joursRestants <= 3 ? 'haute' : 
               groupe.joursRestants <= 7 ? 'moyenne' : 'basse',
      statut: groupe.joursRestants < 0 ? 'retard' : 
             groupe.joursRestants === 0 ? 'aujourd' : 'avenir',
      heureActe: groupe.heureActe,
      typeCategorie: groupe.typeCategorie,
      isGrouped: true
    });
  } else if (groupe.animaux.length === 1) {
    // Un seul animal - garder l'ID réel
    const animal = groupe.animaux[0];
    echeancesTemp.push({
      id: groupe.acteIds[0], // VRAI ID de l'acte
      type: 'echeance',
      titre: groupe.nomActe || groupe.typeCategorie,
      animalNom: animal?.nom || 'Animal inconnu',
      animalId: animal?.id || null,
      date: groupe.date,
      dateStr: groupe.dateActe,
      joursRestants: groupe.joursRestants,
      priority: groupe.joursRestants < 0 ? 'retard' : 
               groupe.joursRestants === 0 ? 'aujourd' :
               groupe.joursRestants <= 3 ? 'haute' : 
               groupe.joursRestants <= 7 ? 'moyenne' : 'basse',
      statut: groupe.joursRestants < 0 ? 'retard' : 
             groupe.joursRestants === 0 ? 'aujourd' : 'avenir',
      heureActe: groupe.heureActe,
      typeCategorie: groupe.typeCategorie
    });
  }
});
      
        





        // Trier par date croissante (plus urgent en premier)
        echeancesTemp.sort((a, b) => a.date - b.date);
        
        // PAS DE LIMITE - on prend tout
        setEcheances(echeancesTemp);
        
      } catch (error) {
        console.error('Erreur chargement échéances:', error);
      } finally {
        setLoadingEcheances(false);
      }
    };
    
    loadEcheances();
    
    // Recharger toutes les heures
    const interval = setInterval(loadEcheances, 3600000);
    return () => clearInterval(interval);
  }, []);

  // Fermer un ticket
  const closeTicket = async (ticketId) => {
    try {
      const ticketRef = doc(db, 'tickets', ticketId);
      const now = new Date().toISOString();
      
      await updateDoc(ticketRef, {
        statut: 'cloture',
        dateCloture: now,
        historique: arrayUnion({
          date: now,
          acteur: 'Utilisateur',
          action: 'cloture'
        })
      });
      
      // Fermer les modals après succès
      setShowCloseConfirm(false);
      setTicketToClose(null);
      if (selectedTicket?.id === ticketId) {
        setSelectedTicket(null);
      }
    } catch (error) {
      console.error('Erreur fermeture ticket:', error);
      alert('Erreur lors de la fermeture du ticket');
    }
  };

  // Demander confirmation avant de fermer
  const handleCloseTicket = (ticketId, e) => {
    e?.stopPropagation();
    setTicketToClose(ticketId);
    setShowCloseConfirm(true);
  };

  // Obtenir la couleur du post-it selon le type et la priorité
  const getPostitColor = (type, priority) => {
    if (type === 'medical') {
      const base = {
        haute: 'bg-blue-200 border-blue-400',
        moyenne: 'bg-blue-100 border-blue-300',
        basse: 'bg-sky-100 border-sky-300'
      }[priority] || 'bg-blue-100 border-blue-300';
      
      const ring = {
        haute: 'shadow-lg ring-2 ring-offset-2 ring-blue-400',
        moyenne: 'shadow-md',
        basse: 'shadow-sm',
      }[priority] || 'shadow-sm';
      
      return `${base} ${ring}`;
    }
    
    if (type === 'technique') {
      const base = {
        haute: 'bg-purple-200 border-purple-400',
        moyenne: 'bg-purple-100 border-purple-300',
        basse: 'bg-violet-100 border-violet-300'
      }[priority] || 'bg-purple-100 border-purple-300';
      
      const ring = {
        haute: 'shadow-lg ring-2 ring-offset-2 ring-purple-400',
        moyenne: 'shadow-md',
        basse: 'shadow-sm',
      }[priority] || 'shadow-sm';
      
      return `${base} ${ring}`;
    }
    
    return 'bg-gray-100 border-gray-200 shadow-sm';
  };

  // Obtenir l'icône selon le type
  const getIcon = (type) => {
    switch(type) {
      case 'medical':
        return <FaHandHoldingMedical className="h-4 w-4" />;
      case 'technique':
        return <FaWrench className="h-4 w-4" />;
      default:
        return <LuLayoutDashboard className="h-4 w-4" />;
    }
  };

  // Formater la date et l'heure
  const formatDateTime = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', { 
      day: '2-digit', 
      month: '2-digit',
      year: 'numeric'
    }) + ' à ' + date.toLocaleTimeString('fr-FR', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Calculer le temps écoulé depuis la création
  const getTimeSinceCreation = (dateString) => {
    if (!dateString) return '';
    
    const now = new Date();
    const created = new Date(dateString);
    const diffMs = now - created;
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const diffHours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    
    if (diffDays > 0) {
      return `${diffDays}j ${diffHours}h`;
    } else {
      return `${diffHours}h`;
    }
  };

  // Filtrer les tickets par type
  const medicalTickets = tickets.filter(t => t.type === 'medical');
  const technicalTickets = tickets.filter(t => t.type === 'technique');


  // Fonction helper pour obtenir le label de la sous-rubrique
  const getSubTypeLabel = (subType) => {
    const labels = {
      // Médical
      'soins': 'Soins',
      'marechalerie': 'Maréchalerie',
      'dentisterie': 'Dentisterie',
      // Technique
      'infrastructure': 'Infrastructure',
      'eau_alimentation': 'Eau & Alimentation',
      'equipements': 'Équipements',
      'terrain': 'Terrain',
      'autres': 'Autres'
    };
    return labels[subType] || subType;
  };

  // Composant pour un ticket dans une colonne
const TicketCard = ({ ticket }) => (
  <div
    className={`relative p-4 rounded-lg border-2 ${
      getPostitColor(ticket.type, ticket.priority)
    } cursor-pointer hover:scale-105 transition-transform hover:z-10`}
    onClick={() => setSelectedTicket(ticket)}
  >
      <div className="flex items-start justify-between mb-2">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            {getIcon(ticket.type)}
            <span className="text-xs font-medium uppercase tracking-wide">
              {ticket.type}
            </span>
          </div>
          {/* Affichage de la rubrique et sous-rubrique pour les tickets techniques */}
          {ticket.type === 'technique' && ticket.subType && (
            <div className="text-xs text-gray-600 ml-6">
              {ticket.category && (
                <span>{ticket.category}</span>
              )}
              {ticket.category && ticket.subType && (
                <span> • </span>
              )}
              <span>{getSubTypeLabel(ticket.subType)}</span>
            </div>
          )}
        </div>
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleCloseTicket(ticket.id, e);
          }}
          className="rounded p-1 text-gray-500 hover:text-green-600 hover:bg-white/60"
          aria-label="Clôturer le ticket"
          title="Clôturer"
        >
          <CheckCircle className="h-4 w-4" />
        </button>
      </div>

      {ticket.type === 'medical' && ticket.horseName && (
        <h3 className="font-semibold text-gray-900 mb-1">
          {ticket.horseName}
        </h3>
      )}

      <h4 className={`${ticket.type === 'medical' ? 'text-sm font-medium text-gray-700 mb-2' : 'font-semibold text-gray-900 mb-2'}`}>
        {ticket.title || `Ticket ${ticket.type}`}
      </h4>

      <p className="text-sm text-gray-700 mb-3 line-clamp-2">
        {ticket.message || ticket.content}
      </p>

      <div className="space-y-1">
        <div className="text-xs text-gray-600">
          {formatDateTime(ticket.dateCreation)}
        </div>
        <div className="text-xs font-medium text-gray-700">
          Ticket ouvert depuis : {getTimeSinceCreation(ticket.dateCreation)}
        </div>
      </div>

      <div className="mt-2">
        <span
          className={[
            'px-2 py-1 rounded-full text-xs font-medium',
            ticket.priority === 'haute'
              ? ticket.type === 'medical' 
                ? 'bg-blue-200 text-blue-800'
                : 'bg-purple-200 text-purple-800'
              : ticket.priority === 'moyenne'
              ? ticket.type === 'medical'
                ? 'bg-blue-100 text-blue-700'
                : 'bg-purple-100 text-purple-700'
              : ticket.type === 'medical'
                ? 'bg-sky-100 text-sky-700'
                : 'bg-violet-100 text-violet-700',
          ].join(' ')}
        >
          Priorité : {ticket.priority}
        </span>
      </div>
    </div>
  );

  // Composant pour une carte d'échéance - NOUVEAU COMPOSANT COMME TicketCard
  const EcheanceCard = ({ echeance }) => (
    <div
      className={`relative p-4 rounded-lg border-2 ${
        echeance.statut === 'retard' 
          ? 'bg-red-100 border-red-300 shadow-lg ring-2 ring-red-400' 
          : echeance.type === 'rappel'
          ? 'bg-yellow-100 border-yellow-300 shadow-md'
          : 'bg-orange-100 border-orange-300 shadow-md'
      } cursor-pointer hover:scale-105 transition-transform hover:z-10`}
      
  
      

onClick={() => {
  // Pour les échéances groupées
  if (echeance.id.startsWith('groupe_') && echeance.acteIds) {
    // Passer tous les IDs des actes au format URL
    const acteIdsParam = echeance.acteIds.join(',');
    navigate(`/actes?groupedActes=${acteIdsParam}&type=${echeance.typeCategorie}`);
    return;
  }
  
  // Pour un acte normal
  const acteId = echeance.type === 'rappel' ? echeance.id.replace('rappel-', '') : echeance.id;
  
  if (echeance.animauxGroupes && echeance.animauxGroupes.length > 0) {
    navigate(`/actes?acteId=${acteId}&openModal=true`);
  } else {
    navigate(`/actes?acteId=${acteId}`);
  }
}}
    >
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          {echeance.type === 'rappel' ? (
            <>
              <Bell className="h-4 w-4 text-yellow-700" />
              <span className="text-xs font-medium uppercase tracking-wide text-yellow-700">
                Rappel
              </span>
            </>
          ) : echeance.statut === 'retard' ? (
            <>
              <AlertTriangle className="h-4 w-4 text-red-700" />
              <span className="text-xs font-medium uppercase tracking-wide text-red-700">
                En retard
              </span>
            </>
          ) : (
            <>
              <CalendarDays className="h-4 w-4 text-orange-700" />
              <span className="text-xs font-medium uppercase tracking-wide text-orange-700">
                Échéance
              </span>
            </>
          )}
        </div>
        


        <span className={`px-2 py-1 rounded-full text-xs font-medium ${
          echeance.statut === 'retard' 
            ? 'bg-red-200 text-red-800 animate-pulse'
            : echeance.statut === 'aujourd'
            ? 'bg-green-200 text-green-800 font-bold'
            : echeance.priority === 'haute' 
            ? 'bg-red-100 text-red-800'
            : echeance.priority === 'moyenne'
            ? 'bg-orange-100 text-orange-800'
            : 'bg-green-100 text-green-800'
        }`}>
          {echeance.statut === 'retard' 
            ? `Retard: ${Math.abs(echeance.joursRestants)}j`
            : echeance.statut === 'aujourd'
            ? "Aujourd'hui !"
            : echeance.joursRestants === 1
            ? "Demain"
            : `Dans ${echeance.joursRestants}j`
          }
        </span>




      </div>
      
{/* Catégorie principale en majuscules */}
      <div className="text-xs font-semibold text-gray-600 uppercase tracking-wide mb-1">
        {echeance.typeCategorie || 'AUTRE'}
      </div>
      
      {/* Nom de l'acte */}
      <h4 className="font-semibold text-gray-900 mb-2">
        {echeance.type === 'rappel' ? echeance.titre.replace('Rappel: ', '') : echeance.titre}
      </h4>
      
      {/* Animal(aux) concerné(s) */}
<div className="flex items-start gap-2 text-sm text-gray-700">
        <GiHorseHead className="h-4 w-4 mt-0.5" />
        <span>
          {echeance.animauxNoms && echeance.animauxNoms.length > 0 
            ? (echeance.animauxNoms.length <= 3 
                ? echeance.animauxNoms.join(', ')
                : `${echeance.animauxNoms.slice(0, 2).join(', ')} et ${echeance.animauxNoms.length - 2} autre${echeance.animauxNoms.length > 3 ? 's' : ''}`)
            : echeance.animalNom || 'Animal inconnu'}
        </span>
      </div>
      
      {echeance.type === 'rappel' && (
        <div className="mt-2 pt-2 border-t border-yellow-200">
          <p className="text-xs text-gray-600 flex items-center gap-1">
            <Clock className="h-3 w-3" />
            Acte prévu le {new Date(echeance.dateEcheance).toLocaleDateString('fr-FR')}
          </p>
        </div>
      )}
      
      {echeance.heureActe && (
        <p className="text-xs text-gray-600 mt-1 flex items-center gap-1">
          <Clock className="h-3 w-3" />
          {echeance.heureActe}
        </p>
      )}
    </div>
  );

  // Modal de sélection du type de ticket
  const TicketTypeSelectionModal = () => {
    if (!showNewTicketModal) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
        <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
          <h2 className="text-xl font-semibold mb-4">Nouveau ticket</h2>
          <p className="text-gray-600 mb-6">Quel type de ticket souhaitez-vous créer ?</p>
          
          <div className="grid grid-cols-2 gap-4">
            <button
              onClick={() => {
                setShowNewTicketModal(false);
                setShowMedicalModal(true);
              }}
              className="p-6 bg-blue-50 hover:bg-blue-100 border-2 border-blue-300 rounded-lg transition-all flex flex-col items-center gap-3"
            >
              <FaHandHoldingMedical className="h-8 w-8 text-blue-600" />
              <div>
                <div className="font-semibold text-blue-900">Médical</div>
                <p className="text-xs text-blue-700 mt-1">Soins vétérinaires</p>
              </div>
            </button>
            
            <button
              onClick={() => {
                setShowNewTicketModal(false);
                setShowTechnicalModal(true);
              }}
              className="p-6 bg-purple-50 hover:bg-purple-100 border-2 border-purple-300 rounded-lg transition-all flex flex-col items-center gap-3"
            >
              <FaWrench className="h-8 w-8 text-purple-600" />
              <div>
                <div className="font-semibold text-purple-900">Technique</div>
                <p className="text-xs text-purple-700 mt-1">Maintenance</p>
              </div>
            </button>
          </div>
          
          <button
            onClick={() => setShowNewTicketModal(false)}
            className="w-full mt-6 px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50"
          >
            Annuler
          </button>
        </div>
      </div>
    );
  };

  // Modal de visualisation de ticket
  const TicketViewModal = () => {
    const navigate = useNavigate();
    
    if (!selectedTicket) return null;

    const getSubTypeLabel = (subType) => {
      const labels = {
        'soins': 'Soins',
        'marechalerie': 'Maréchalerie',
        'dentisterie': 'Dentisterie',
        'infrastructure': 'Infrastructure',
        'eau_alimentation': 'Eau & Alimentation',
        'equipements': 'Équipements',
        'terrain': 'Terrain',
        'autres': 'Autres'
      };
      return labels[subType] || subType;
    };

    const handleLocateOnMap = async () => {
      try {
        if (selectedTicket.type === 'medical') {
          if (selectedTicket.horseName) {
            const animauxQuery = query(
              collection(db, 'animaux'),
              where('nom', '==', selectedTicket.horseName)
            );
            const animauxSnapshot = await getDocs(animauxQuery);
            
            if (!animauxSnapshot.empty) {
              const animalDoc = animauxSnapshot.docs[0];
              const animalId = animalDoc.id;
              const animalData = animalDoc.data();
              
              if (animalData.zoneId) {
                navigate('/carte', { 
                  state: { 
                    focusAnimalId: animalId,
                    ticketInfo: {
                      type: selectedTicket.type,
                      title: selectedTicket.title,
                      message: selectedTicket.message || selectedTicket.content
                    }
                  } 
                });
              } else {
                alert(`L'animal "${selectedTicket.horseName}" n'est assigné à aucune zone sur la carte.`);
              }
            } else {
              alert(`Animal "${selectedTicket.horseName}" non trouvé dans la base de données`);
            }
          }
        } 
        else if (selectedTicket.type === 'technique') {
          if (selectedTicket.gpsLocation) {
            navigate('/carte', { 
              state: { 
                focusTechnicalGPS: {
                  lat: selectedTicket.gpsLocation.latitude,
                  lng: selectedTicket.gpsLocation.longitude
                },
                ticketInfo: {
                  type: selectedTicket.type,
                  title: selectedTicket.title,
                  message: selectedTicket.message || selectedTicket.content,
                  priority: selectedTicket.priority
                }
              } 
            });
          } 
          else if (selectedTicket.zoneId || selectedTicket.zoneName) {
            navigate('/carte', { 
              state: { 
                focusZoneName: selectedTicket.zoneName,
                ticketInfo: {
                  type: selectedTicket.type,
                  title: selectedTicket.title,
                  message: selectedTicket.message || selectedTicket.content,
                  priority: selectedTicket.priority
                }
              } 
            });
          } else {
            alert('Ce ticket technique n\'a pas de localisation définie');
          }
        }
      } catch (error) {
        console.error('Erreur lors de la localisation:', error);
        alert('Erreur lors de la localisation sur la carte : ' + error.message);
      }
    };

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
        <div className="bg-white rounded-lg shadow-xl max-w-lg w-full max-h-[90vh] overflow-y-auto p-6">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-xl font-semibold">Détails du ticket</h2>
            <button
              onClick={() => setSelectedTicket(null)}
              className="p-2 hover:bg-gray-100 rounded-full"
            >
              <X className="h-5 w-5" />
            </button>
          </div>

          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                {getIcon(selectedTicket.type)}
                <span className="font-medium capitalize">{selectedTicket.type}</span>
                {selectedTicket.subType && (
                  <span className="text-sm text-gray-600">
                    - {getSubTypeLabel(selectedTicket.subType)}
                  </span>
                )}
              </div>
              <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                selectedTicket.priority === 'haute' ? 'bg-red-100 text-red-800' :
                selectedTicket.priority === 'moyenne' ? 'bg-orange-100 text-orange-800' :
                'bg-green-100 text-green-800'
              }`}>
                {selectedTicket.priority}
              </span>
            </div>

            {selectedTicket.type === 'medical' && selectedTicket.horseName && (
              <div className="bg-gray-50 p-3 rounded-lg">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    {selectedTicket.animalType === 'equide' || (!selectedTicket.animalType && selectedTicket.horseSire) ? (
                      <GiHorseHead className="h-5 w-5 text-gray-600" />
                    ) : (
                      <PiFarm className="h-5 w-5 text-gray-600" />
                    )}
                    <div>
                      <span className="text-sm text-gray-600">Animal: </span>
                      <span className="font-semibold text-gray-900">{selectedTicket.horseName}</span>
                      {selectedTicket.horseSire && (
                        <span className="text-xs text-gray-500 ml-2">(SIRE: {selectedTicket.horseSire})</span>
                      )}
                    </div>
                  </div>
                  <button
                    onClick={handleLocateOnMap}
                    className="p-2 bg-blue-100 hover:bg-blue-200 rounded-full transition-colors"
                    title="Localiser sur la carte"
                  >
                    <MdWhereToVote className="h-5 w-5 text-blue-600" />
                  </button>
                </div>
              </div>
            )}

            {selectedTicket.type === 'technique' && selectedTicket.zoneName && (
              <div className="bg-gray-50 p-3 rounded-lg">
                <div className="flex items-center justify-between">
                  <div>
                    <span className="text-sm text-gray-600">Zone: </span>
                    <span className="font-semibold text-gray-900">{selectedTicket.zoneName}</span>
                  </div>
                  <button
                    onClick={() => {
                      navigate('/tableau-bord', { 
                        state: { 
                          zoneId: selectedTicket.zoneId,
                          zoneName: selectedTicket.zoneName,
                          filter: 'technique'
                        }
                      });
                      setSelectedTicket(null);
                    }}
                    className="text-sm px-3 py-1 bg-purple-100 text-purple-700 rounded hover:bg-purple-200"
                  >
                    Voir tous les tickets de cette zone
                  </button>
                </div>
              </div>
            )}

            <div>
              <h3 className="font-semibold text-lg">
                {selectedTicket.title || `Ticket ${selectedTicket.type}`}
              </h3>
            </div>

            <div>
              <h4 className="font-medium text-gray-700 mb-1">Description:</h4>
              <p className="text-sm text-gray-600 bg-gray-50 p-3 rounded-lg">
                {selectedTicket.message || selectedTicket.content}
              </p>
            </div>

            {selectedTicket.type === 'technique' && (
              <div className="flex justify-center">
                <button
                  onClick={handleLocateOnMap}
                  className="flex items-center gap-2 px-4 py-2 bg-purple-100 hover:bg-purple-200 rounded-lg transition-colors"
                >
                  <MdWhereToVote className="h-5 w-5 text-purple-600" />
                  <span className="text-sm font-medium text-purple-700">Localiser l'intervention</span>
                </button>
              </div>
            )}

            <div className="border-t pt-3 space-y-1 text-sm text-gray-500">
              <div className="flex items-center gap-2">
                <Clock className="h-3 w-3" />
                <span>Créé le {formatDateTime(selectedTicket.dateCreation)}</span>
              </div>
              <div className="flex items-center gap-2">
                <User className="h-3 w-3" />
                <span>Par {selectedTicket.acteur}</span>
              </div>
            </div>

            <div className="flex justify-end gap-3 pt-4 border-t">
              <button
                onClick={() => setSelectedTicket(null)}
                className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50"
              >
                Fermer
              </button>
              {selectedTicket.type === 'medical' && selectedTicket.horseId && (
                <button
                  onClick={() => navigate(`/animaux/${selectedTicket.horseId}`)}
                  className="px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700"
                >
                  Voir Fiche
                </button>
              )}
              <button
                onClick={() => {
                  handleCloseTicket(selectedTicket.id);
                }}
                className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 flex items-center gap-2"
              >
                <CheckCircle className="h-4 w-4" />
                Clôturer
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {/* Utilisation d'un div au lieu de PageWrapper pour contrôler la largeur */}
      <div className="min-h-screen bg-gray-50">
        {/* Header avec titre et bouton - pleine largeur */}
        <div className="w-full px-4 sm:px-6 lg:px-8 py-6 bg-white border-b">
          <div className="flex items-center justify-between max-w-[1920px] mx-auto">
            <div className="flex items-center gap-3">
              <LuLayoutDashboard className="h-6 w-6" />
              <h1 className="text-2xl font-bold">Pilotage</h1>
            </div>
            <div className="flex items-center gap-2">
              <button
                onClick={() => {
                  setTicketType('medical');
                  setShowNewTicketModal(true);
                }}
                className="flex items-center gap-2 px-4 py-2 bg-black text-white rounded-lg hover:bg-gray-800 transition-colors"
              >
                <Plus className="h-4 w-4" />
                Nouveau ticket
              </button>
              <button
                onClick={() => navigate('/tableau-bord-liste')}
                className="flex items-center gap-2 px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
              >
                <ClipboardList className="h-4 w-4" />
                Vue Liste
              </button>
            </div>
          </div>
        </div>

        {/* Contenu principal - pleine largeur avec padding */}
        <div className="w-full px-4 sm:px-6 lg:px-8 py-6 max-w-[1920px] mx-auto overflow-visible">
          {/* Messages de filtrage */}
          {filterHorseId && filterType === 'medical' && (
            <div className="mb-6 p-3 bg-blue-50 border border-blue-200 rounded-lg flex items-center justify-between">
              <span className="text-sm text-blue-800">
                Tickets médicaux filtrés pour un animal spécifique
              </span>
              <button
                onClick={() => {
                  navigate('/tableau-bord');
                  window.location.reload();
                }}
                className="text-sm text-blue-600 hover:text-blue-800 underline"
              >
                Voir tous les tickets
              </button>
            </div>
          )}
          
          {filterZoneId && filterType === 'technique' && (
            <div className="mb-6 p-3 bg-purple-50 border border-purple-200 rounded-lg flex items-center justify-between">
              <span className="text-sm text-purple-800">
                Tickets techniques filtrés pour la zone : {filterZoneName}
              </span>
              <button
                onClick={() => {
                  navigate('/tableau-bord');
                  window.location.reload();
                }}
                className="text-sm text-purple-600 hover:text-purple-800 underline"
              >
                Voir tous les tickets
              </button>
            </div>
          )}

          {/* Version Desktop XL - 4 colonnes côte à côte */}
          <div className="hidden xl:grid xl:grid-cols-4 gap-8 w-full overflow-visible">
            {/* Colonne Tickets Médicaux */}
            <div className="space-y-4 overflow-visible">
              <div className="relative bg-blue-50 p-4 rounded-lg border-2 border-blue-300 overflow-hidden">
                <FaHandHoldingMedical className="absolute right-2 top-1/2 -translate-y-1/2 h-16 w-16 text-blue-200 opacity-50" />
                <div className="relative z-10">
                  <h3 className="font-bold text-blue-800 text-lg">Tickets Médicaux</h3>
                  <p className="text-sm text-blue-600 mt-1">
                    {medicalTickets.length} ticket{medicalTickets.length > 1 ? 's' : ''} ouvert{medicalTickets.length > 1 ? 's' : ''}
                  </p>
                </div>
              </div>
              

              <div className="space-y-3 overflow-visible">
                {loading ? (
                  <div className="text-center py-8">
                    <div className="animate-spin h-6 w-6 border-3 border-blue-600 border-t-transparent rounded-full mx-auto"></div>
                  </div>
                ) : medicalTickets.length > 0 ? (
                  medicalTickets.map(ticket => (
                    <TicketCard key={ticket.id} ticket={ticket} />
                  ))
                ) : (
                  <div className="text-center py-8 text-gray-500 text-sm">
                    Aucun ticket médical
                  </div>
                )}
              </div>
            </div>

            {/* Colonne Tickets Techniques */}
            <div className="space-y-4 overflow-visible">
              <div className="relative bg-purple-50 p-4 rounded-lg border-2 border-purple-300 overflow-hidden">
                <FaWrench className="absolute right-2 top-1/2 -translate-y-1/2 h-16 w-16 text-purple-200 opacity-50" />
                <div className="relative z-10">
                  <h3 className="font-bold text-purple-800 text-lg">Tickets Techniques</h3>
                  <p className="text-sm text-purple-600 mt-1">
                    {technicalTickets.length} ticket{technicalTickets.length > 1 ? 's' : ''} ouvert{technicalTickets.length > 1 ? 's' : ''}
                  </p>
                </div>
              </div>
              
              <div className="space-y-3 overflow-visible">
                {loading ? (
                  <div className="text-center py-8">
                    <div className="animate-spin h-6 w-6 border-3 border-purple-600 border-t-transparent rounded-full mx-auto"></div>
                  </div>
                ) : technicalTickets.length > 0 ? (
                  technicalTickets.map(ticket => (
                    <TicketCard key={ticket.id} ticket={ticket} />
                  ))
                ) : (
                  <div className="text-center py-8 text-gray-500 text-sm">
                    Aucun ticket technique
                  </div>
                )}
              </div>
            </div>






            {/* Colonne Échéances à venir */}
            <div className="space-y-4 overflow-visible relative">
              <div className="relative bg-orange-50 p-4 rounded-lg border-2 border-orange-300 overflow-hidden">
                <LuBellRing className="absolute right-2 top-1/2 -translate-y-1/2 h-16 w-16 text-orange-200 opacity-50" />
                <div className="relative z-10">
                  <h3 className="font-bold text-orange-800 text-lg">Échéances à venir</h3>
                  <p className="text-sm text-orange-600 mt-1">
                    {echeances.length} échéance{echeances.length > 1 ? 's' : ''} (30 jours)
                  </p>
                </div>
              </div>
              
              {/* Conteneur avec hauteur max et scroll */}
              {/* Même pattern que les tickets - pas de max-height */}
              <div className="space-y-3">
                {loadingEcheances ? (
                  <div className="text-center py-8">
                    <div className="animate-spin h-6 w-6 border-3 border-orange-600 border-t-transparent rounded-full mx-auto"></div>
                  </div>
                ) : echeances.length > 0 ? (
                  
                  
echeances.map(echeance => (
                    <EcheanceCard key={echeance.id} echeance={echeance} />
                  ))


                ) : (
                  <div className="text-center py-8 text-gray-500 text-sm">
                    Aucune échéance dans les 30 prochains jours
                  </div>
                )}
              </div>
              
              {/* Indicateur de scroll si nécessaire */}
              {echeances.length > 5 && (
                <div className="text-center text-xs text-gray-400 italic">
                  ↓ Faire défiler pour voir plus ↓
                </div>
              )}
            </div>




            {/* Colonne Statistiques - Desktop */}
            <div className="sticky top-4 h-fit">
              <StatisticsModule layout="vertical" />
            </div>
          </div>

          {/* Version Tablette/Medium - 3 colonnes + stats en dessous */}
          <div className="hidden lg:grid xl:hidden grid-cols-3 gap-6 w-full">
            {/* Les 3 premières colonnes */}
            {/* Colonne Tickets Médicaux */}
            <div className="space-y-4">
              <div className="relative bg-blue-50 p-4 rounded-lg border-2 border-blue-300 overflow-hidden">
                <FaHandHoldingMedical className="absolute right-2 top-1/2 -translate-y-1/2 h-16 w-16 text-blue-200 opacity-50" />
                <div className="relative z-10">
                  <h3 className="font-bold text-blue-800 text-lg">Tickets Médicaux</h3>
                  <p className="text-sm text-blue-600 mt-1">
                    {medicalTickets.length} ticket{medicalTickets.length > 1 ? 's' : ''} ouvert{medicalTickets.length > 1 ? 's' : ''}
                  </p>
                </div>
              </div>
              
              <div className="space-y-3">
                {loading ? (
                  <div className="text-center py-8">
                    <div className="animate-spin h-6 w-6 border-3 border-blue-600 border-t-transparent rounded-full mx-auto"></div>
                  </div>
                ) : medicalTickets.length > 0 ? (
                  medicalTickets.map(ticket => (
                    <TicketCard key={ticket.id} ticket={ticket} />
                  ))
                ) : (
                  <div className="text-center py-8 text-gray-500 text-sm">
                    Aucun ticket médical
                  </div>
                )}
              </div>
            </div>

            {/* Colonne Tickets Techniques */}
            <div className="space-y-4">
              <div className="relative bg-purple-50 p-4 rounded-lg border-2 border-purple-300 overflow-hidden">
                <FaWrench className="absolute right-2 top-1/2 -translate-y-1/2 h-16 w-16 text-purple-200 opacity-50" />
                <div className="relative z-10">
                  <h3 className="font-bold text-purple-800 text-lg">Tickets Techniques</h3>
                  <p className="text-sm text-purple-600 mt-1">
                    {technicalTickets.length} ticket{technicalTickets.length > 1 ? 's' : ''} ouvert{technicalTickets.length > 1 ? 's' : ''}
                  </p>
                </div>
              </div>
              
              <div className="space-y-3">
                {loading ? (
                  <div className="text-center py-8">
                    <div className="animate-spin h-6 w-6 border-3 border-purple-600 border-t-transparent rounded-full mx-auto"></div>
                  </div>
                ) : technicalTickets.length > 0 ? (
                  technicalTickets.map(ticket => (
                    <TicketCard key={ticket.id} ticket={ticket} />
                  ))
                ) : (
                  <div className="text-center py-8 text-gray-500 text-sm">
                    Aucun ticket technique
                  </div>
                )}
              </div>
            </div>



           {/* Colonne Échéances à venir */}
            <div className="space-y-4">
              <div className="relative bg-orange-50 p-4 rounded-lg border-2 border-orange-300 overflow-hidden">
                <LuBellRing className="absolute right-2 top-1/2 -translate-y-1/2 h-16 w-16 text-orange-200 opacity-50" />
                <div className="relative z-10">
                  <h3 className="font-bold text-orange-800 text-lg">Échéances à venir</h3>
                  <p className="text-sm text-orange-600 mt-1">
                    {echeances.length} échéance{echeances.length > 1 ? 's' : ''} (30 jours)
                  </p>
                </div>
              </div>
              
              {/* Conteneur avec hauteur max et scroll */}
              {/* Conteneur avec hauteur max et scroll - overflow-x-visible ajouté */}
{/* Même pattern que les tickets */}
              <div className="space-y-3">
                {loadingEcheances ? (
                  <div className="text-center py-8">
                    <div className="animate-spin h-6 w-6 border-3 border-orange-600 border-t-transparent rounded-full mx-auto"></div>
                  </div>
                ) : echeances.length > 0 ? (
                  
                  
echeances.map(echeance => (
                    <EcheanceCard key={echeance.id} echeance={echeance} />
                  ))


                ) : (
                  <div className="text-center py-8 text-gray-500 text-sm">
                    Aucune échéance dans les 30 prochains jours
                  </div>
                )}
              </div>
              
              {/* Indicateur de scroll si nécessaire */}
              {echeances.length > 5 && (
                <div className="text-center text-xs text-gray-400 italic">
                  ↓ Faire défiler pour voir plus ↓
                </div>
              )}
            </div>






          </div>

          {/* Stats en dessous pour tablette */}
          <div className="hidden lg:block xl:hidden mt-6">
            <StatisticsModule layout="horizontal" />
          </div>

          {/* Version Mobile - Tout empilé */}
          <div className="lg:hidden space-y-6">
            {/* Tickets Médicaux */}
            <div className="space-y-4">
              <div className="relative bg-blue-50 p-4 rounded-lg border-2 border-blue-300 overflow-hidden">
                <FaHandHoldingMedical className="absolute right-2 top-1/2 -translate-y-1/2 h-16 w-16 text-blue-200 opacity-50" />
                <div className="relative z-10">
                  <h3 className="font-bold text-blue-800 text-lg">Tickets Médicaux</h3>
                  <p className="text-sm text-blue-600 mt-1">
                    {medicalTickets.length} ticket{medicalTickets.length > 1 ? 's' : ''} ouvert{medicalTickets.length > 1 ? 's' : ''}
                  </p>
                </div>
              </div>
              
              <div className="space-y-3">
                {loading ? (
                  <div className="text-center py-8">
                    <div className="animate-spin h-6 w-6 border-3 border-blue-600 border-t-transparent rounded-full mx-auto"></div>
                  </div>
                ) : medicalTickets.length > 0 ? (
                  medicalTickets.map(ticket => (
                    <TicketCard key={ticket.id} ticket={ticket} />
                  ))
                ) : (
                  <div className="text-center py-8 text-gray-500 text-sm">
                    Aucun ticket médical
                  </div>
                )}
              </div>
            </div>

            {/* Tickets Techniques */}
            <div className="space-y-4">
              <div className="relative bg-purple-50 p-4 rounded-lg border-2 border-purple-300 overflow-hidden">
                <FaWrench className="absolute right-2 top-1/2 -translate-y-1/2 h-16 w-16 text-purple-200 opacity-50" />
                <div className="relative z-10">
                  <h3 className="font-bold text-purple-800 text-lg">Tickets Techniques</h3>
                  <p className="text-sm text-purple-600 mt-1">
                    {technicalTickets.length} ticket{technicalTickets.length > 1 ? 's' : ''} ouvert{technicalTickets.length > 1 ? 's' : ''}
                  </p>
                </div>
              </div>
              
              <div className="space-y-3">
                {loading ? (
                  <div className="text-center py-8">
                    <div className="animate-spin h-6 w-6 border-3 border-purple-600 border-t-transparent rounded-full mx-auto"></div>
                  </div>
                ) : technicalTickets.length > 0 ? (
                  technicalTickets.map(ticket => (
                    <TicketCard key={ticket.id} ticket={ticket} />
                  ))
                ) : (
                  <div className="text-center py-8 text-gray-500 text-sm">
                    Aucun ticket technique
                  </div>
                )}
              </div>
            </div>



{/* Échéances */}
<div className="space-y-4">
  <div className="relative bg-orange-50 p-4 rounded-lg border-2 border-orange-300 overflow-hidden">
    <LuBellRing className="absolute right-2 top-1/2 -translate-y-1/2 h-16 w-16 text-orange-200 opacity-50" />
    <div className="relative z-10">
      <h3 className="font-bold text-orange-800 text-lg">Échéances à venir</h3>
      <p className="text-sm text-orange-600 mt-1">
        {echeances.length} échéance{echeances.length > 1 ? 's' : ''} (30 jours)
      </p>
    </div>
  </div>
  
  <div className="space-y-3">
    {loadingEcheances ? (
      <div className="text-center py-8">
        <div className="animate-spin h-6 w-6 border-3 border-orange-600 border-t-transparent rounded-full mx-auto"></div>
      </div>
    ) : echeances.length > 0 ? (
      
      
echeances.slice(0, 5).map(echeance => (
                    <EcheanceCard key={echeance.id} echeance={echeance} />
                  ))



    ) : (
      <div className="text-center py-8 text-gray-500 text-sm">
        Aucune échéance dans les 30 prochains jours
      </div>
    )}
    
    {echeances.length > 5 && (
      <div className="text-center text-xs text-gray-400 italic">
        Affichage limité aux 5 premières échéances
      </div>
    )}
  </div>
</div>



            

            {/* Statistiques en dernier sur mobile */}
            <div>
              <StatisticsModule layout="horizontal" />
            </div>
          </div>
        </div>
      </div>

      {/* Modals */}
      <TicketTypeSelectionModal />
      <TicketViewModal />
      
      {/* Modal de confirmation de clôture */}
      {showCloseConfirm && ticketToClose && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold">Confirmer la clôture</h3>
              <button
                onClick={() => {
                  setShowCloseConfirm(false);
                  setTicketToClose(null);
                }}
                className="p-2 hover:bg-gray-100 rounded-full"
              >
                <X className="h-5 w-5" />
              </button>
            </div>
            
            <p className="text-gray-600 mb-6">
              Êtes-vous sûr de vouloir clôturer ce ticket ? Cette action marquera le ticket comme résolu.
            </p>
            
            <div className="flex justify-end gap-3">
              <button
                onClick={() => {
                  setShowCloseConfirm(false);
                  setTicketToClose(null);
                }}
                className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50"
              >
                Annuler
              </button>
              <button
                onClick={() => closeTicket(ticketToClose)}
                className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 flex items-center gap-2"
              >
                <CheckCircle className="h-4 w-4" />
                Confirmer la clôture
              </button>
            </div>
          </div>
        </div>
      )}
      
      <TechnicalTicketModal
        isOpen={showTechnicalModal}
        onClose={() => setShowTechnicalModal(false)}
        fromDashboard={true}
        onSuccess={() => {
          setShowTechnicalModal(false);
        }}
      />
      <MedicalTicketModal
        isOpen={showMedicalModal}
        onClose={() => setShowMedicalModal(false)}
        horse={null}
        onSuccess={() => {
          setShowMedicalModal(false);
        }}
      />
    </>
  );
}